import { render, staticRenderFns } from "./ProductionChart.vue?vue&type=template&id=54cff096&"
import script from "./ProductionChart.vue?vue&type=script&lang=js&"
export * from "./ProductionChart.vue?vue&type=script&lang=js&"
import style0 from "./ProductionChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports